export var DEFAULT_CALLBACK_DELAY = 0;